<template>
  <v-alert v-if="error"
           type="error"
           tile
           class="mb-0">
    {{ error.response?.data?.message || error.message || error || 'Unknown error' }}
  </v-alert>
</template>
<script>
export default {
  props: {
    error: {
      type: Object,
      required: false,
    }
  }
}
</script>
